// extracted by mini-css-extract-plugin
export var readonly = "_jj-1";
export var star = "_jj-0";